import { getDomainHints } from "@/lib/domain-hints";
import { useWorkspaces } from "@/store/workspaces";

const COPY = {
  entity: {
    eyebrow: "No data yet",
    title: "Empty workspace",
    intro: "Use the chat panel to add entities. Try:",
    hintKey: "entityHint" as const,
  },
  signal: {
    eyebrow: "No signals yet",
    title: "Timeline is empty",
    intro: "Use the chat panel to add events. Try:",
    hintKey: "signalHint" as const,
  },
};

export function DomainAwareEmpty({
  workspaceId,
  kind,
}: {
  workspaceId?: string;
  kind: keyof typeof COPY;
}) {
  const { getById } = useWorkspaces();
  const ws = workspaceId ? getById(workspaceId) : undefined;
  const hints = getDomainHints(ws?.domain);
  const copy = COPY[kind];
  const example = hints[copy.hintKey];

  return (
    <div className="absolute inset-0 grid place-items-center text-center px-6">
      <div className="max-w-sm">
        <div className="label-eyebrow mb-2">{copy.eyebrow}</div>
        <h3 className="text-[15px] font-semibold mb-2">{copy.title}</h3>
        <p className="text-[12px] text-muted-foreground">
          {copy.intro}{" "}
          <span className="text-foreground/85 italic">{example}</span>
        </p>
      </div>
    </div>
  );
}
